module.exports = __webpack_public_path__ + "img/indicator.65686e1c.png";